/**
 *  Created by pw on 2019-10-23 15:12.
 */
export var ID = '@check-in';
export default {
    ID: ID,
    SAVE_ATTENDANCE: ID + "/SAVE_ATTENDANCE",
    GET_ALL_ATTENDANCE: ID + "/GET_ALL_ATTENDANCE"
};
